import React from 'react';

/* Planifié / consommé Jira / vendu d'une phase, avec la jauge de consommation. */
export default function PhaseProgress({
  plannedDays,
  jiraDays,
  vendu,
  consoPct,
  planPct,
  consoColor,
  planColor,
}) {
  return (
    <>
      <div className="text-[11px] font-medium whitespace-nowrap">
        <span className="font-bold" style={{ color: planColor }}>
          {plannedDays}j
        </span>
        <span className="text-grey-dark"> plan</span>
        {jiraDays > 0 && (
          <>
            <span className="text-grey-pale"> · </span>
            <span className="font-bold" style={{ color: consoColor }}>
              {jiraDays}j
            </span>
            <span className="text-grey-dark"> conso</span>
          </>
        )}
        {vendu > 0 && <span className="text-grey-dark"> / {vendu}j</span>}
      </div>
      {vendu > 0 && (
        <div
          className="h-[5px] bg-[#e7e2db] rounded-[3px] overflow-hidden relative max-w-[200px]"
          title={`Consommé Jira ${Math.round(consoPct)}% · Planifié ${Math.round(planPct)}%`}
        >
          <div
            className="absolute [inset:0] rounded-[3px]"
            style={{ width: `${Math.min(100, consoPct)}%`, background: consoColor }}
          />
        </div>
      )}
    </>
  );
}
